import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';
import { ChargeBulkSummaryModel } from '../../../../core/models/data/charge-bulk-summary.model';
import { CurrencyModel } from '../../../../core/models/data/currency.model';
import { CurrencyDisplayPipe } from '../../../../core/pipes/currency/currency.pipe';

export type InvoiceAgingBucket = 'all' | 'current' | 'pastDue';

@Component({
  selector: 'ms-invoice-aging-summary-cards',
  imports: [CommonModule, FaDuotoneIconComponent, CurrencyDisplayPipe],
  templateUrl: './invoice-aging-summary-cards.component.html',
  styleUrl: './invoice-aging-summary-cards.component.scss'
})
export class InvoiceAgingSummaryCardsComponent {
  public summary = input<ChargeBulkSummaryModel | undefined>(undefined);
  public currency = input<CurrencyModel | undefined>(undefined);
  public isLoading = input<boolean>(false);
  public selectedBucket = input<InvoiceAgingBucket>('all');

  public bucketSelected = output<InvoiceAgingBucket>();

  public onCardClick(bucket: InvoiceAgingBucket): void {
    this.bucketSelected.emit(bucket);
  }
}
